import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInventoryUpload } from "src/models/Products/InventoryUpload.models";

interface AdjustmentUploadState {
  uploadsAdjustments: IInventoryUpload[];
  uploadAdjustmentToEdit: IInventoryUpload | null;
}

const initialState: AdjustmentUploadState = {
  uploadsAdjustments: [],
  uploadAdjustmentToEdit: null,
};

const uploadAdjustmentInventorySlice = createSlice({
  name: "UploadAdjustmentInventory",
  initialState,
  reducers: {
    setAdjustmentUploadList: (state, action: PayloadAction<IInventoryUpload[]>) => {
      state.uploadsAdjustments = action.payload;
    },
    concatListAdjustmentUpload: (
      state: AdjustmentUploadState,
      action: PayloadAction<IInventoryUpload[]>
    ) => {
      state.uploadsAdjustments = [...state.uploadsAdjustments.concat(action.payload)];
    },
    setAdjustmentUploadToEdit: (state, action: PayloadAction<IInventoryUpload | null>) => {
      state.uploadAdjustmentToEdit = action.payload;
    },
    addAdjustmentUpload: (state, action: PayloadAction<IInventoryUpload>) => {
      state.uploadsAdjustments.push(action.payload);
    },
    applyDetails: (state, action: PayloadAction<number[]>) => {
      const newDetails = state.uploadAdjustmentToEdit?.details?.forEach(element => {
        if (action.payload.includes(element.uploadDetailId))
          element.applied = true;
        return element;
      })

      if (state.uploadAdjustmentToEdit) 
        state.uploadAdjustmentToEdit.details = newDetails ?? [];
    },
    updateAdjustmentUpload: (state, action: PayloadAction<IInventoryUpload>) => {
      let itemIndex = state.uploadsAdjustments.findIndex(
        item => item.uploadId === action.payload.uploadId
      );
      if (itemIndex !== -1) state.uploadsAdjustments[itemIndex] = action.payload;
    },
    deleteAdjustmentUpload: (state, action: PayloadAction<number>) => {
      const newArray = state.uploadsAdjustments.filter(
        item => item.uploadId !== action.payload
      );
      state.uploadsAdjustments = newArray;
    },
    deleteAdjustmentUploadMultipleDetails: (state, action: PayloadAction<number[]>) => {
      const newDetails = state.uploadAdjustmentToEdit?.details?.filter(
        item => !action.payload.includes(item.uploadDetailId) 
      );

      if (state.uploadAdjustmentToEdit) 
        state.uploadAdjustmentToEdit.details = newDetails ?? [];
    },
    deleteAdjustmentUploadDetail: (state, action: PayloadAction<number>) => {
      const newDetails = state.uploadAdjustmentToEdit?.details?.filter(
        item => action.payload != item.uploadDetailId
      );

      if (state.uploadAdjustmentToEdit) 
        state.uploadAdjustmentToEdit.details = newDetails ?? [];
    },
  },
});

export const {
  setAdjustmentUploadList,
  concatListAdjustmentUpload,
  setAdjustmentUploadToEdit,
  addAdjustmentUpload,
  applyDetails,
  updateAdjustmentUpload,
  deleteAdjustmentUpload,
  deleteAdjustmentUploadMultipleDetails,
  deleteAdjustmentUploadDetail,
} = uploadAdjustmentInventorySlice.actions;

export default uploadAdjustmentInventorySlice.reducer;